// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

export const CAPTCHA_V2_KEY = "6LeI9FUdAAAAAMDWSk02W_UDAzjtvmmFywofxnaZ";
export const DROPBOX_CLIENT_ID = "72nlwaeddxnztt9";
export const MS_GRAPH_CLIENT_ID = "7d92c2d6-31c4-4080-a1a1-a003b361d019";
export const BOX_CLIENT_ID = "nkae01x01c2t5klysso9lf2s6eh7tg8p";
export const SHAREFILE_ID = "LKd1PgNck79FEnmctxhQqOJUSJ5VKGdy"
export const GDRIVE_CLIENT_ID = "861033780744-9408m9kipg9sc7n1kg8hupkjh1trpqa1.apps.googleusercontent.com"
export const GDRIVE_SCOPE="https://www.googleapis.com/auth/drive"


// Generate using `node ./src/utilities/codeChallenge.js`
// const CODE_VERIFIER = "ek3MyADBHtfDhrPBWFQdWF66RvEQ3FzRzlArs4JGMZp4DPsS2FQXS89sFOlOTtks1ZTwxBPVS9LwnQg2WHOoYslur3GIHhWRkUaVkWeExykETrJ31QKLIFwUDsuBQTvo";
export const PKCE_CODE_CHALLENGE = "xqElvdwlki_ZhhNfDD4YCSpBbW87XUfuuTt2CSxXdho";